export function extractEmailFromUserString(
  value: string | undefined,
): { name: string; email: string } | null {
  if (value === null) return value;

  if (!value) return { name: '', email: '' };

  const words = value.split(' ');

  const email = words.pop() ?? '';

  const name = words.join(' ');

  return { name, email };
}
